import React from 'react';
import { Link } from 'react-router';
import HeaderMenu from '../../../containers/HeaderMenu';
import HeaderMenuDiscovery from '../../../shared/HeaderMenuDiscovery';
import Logo from '../../Logo';
import getUrl from '@/routes/routes/helpers/getUrl';

import { srOnly } from '../../../base-styles/mixins.module.css';
import { logo, menu } from './styles.module.css';

const Header = ({ selectedLocale, userSelectedLocale, useDiscoveryHeader }) => {
  if (useDiscoveryHeader) {
    return (
      <HeaderMenuDiscovery
        className={menu}
        selectedLocale={selectedLocale}
        userSelectedLocale={userSelectedLocale}
      />
    );
  }

  return (
    <>
      <div className={srOnly}>Let’s Do This</div>
      <Link
        to={getUrl.homepage(selectedLocale)}
        className={logo}
        title="Let’s Do This"
      >
        <Logo />
      </Link>
      <HeaderMenu
        className={menu}
        selectedLocale={selectedLocale}
        userSelectedLocale={userSelectedLocale}
      />
    </>
  );
};

export default Header;
